import { environment } from 'src/environments/environment';

/**
 * Returns URL pathname only (no query, no hash) for Sentry privacy policy.
 * إرجاع مسار URL فقط دون استعلام أو تجزئة — وفق سياسة الخصوصية لـ Sentry
 */
export function sentrySafeHttpPath(url: string): string {
  try {
    if (url.startsWith('http://') || url.startsWith('https://')) {
      return new URL(url).pathname;
    }
    const noQuery = url.split('?')[0].split('#')[0];
    return noQuery.startsWith('/') ? noQuery : `/${noQuery}`;
  } catch {
    return '(path-unavailable)';
  }
}

/** Random sample gate for breadcrumbs (reduces Sentry volume in production). / بوابة أخذ عينات للـ breadcrumbs */
export function shouldEmitSentryBreadcrumb(): boolean {
  const rate = environment.sentry.breadcrumbSampleRate;
  if (rate >= 1) {
    return true;
  }
  if (rate <= 0) {
    return false;
  }
  return Math.random() < rate;
}
